import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HoldService extends BaseApiService {
  protected basePath = '/api/v1';

  /**
   * Place a hold on a bibliographic record.
   * 
   * @param payload Hold details (biblio_id, pickup_library_id, patron_id, etc.)
   */
  placeHold(payload: any): Observable<any> {
    return this.post<any>('/holds', payload);
  }

  getHolds(patronId: number, biblioId?: number): Observable<any[]> {
    const params: any = { patron_id: patronId };
    if (biblioId) {
      params['biblio_id'] = biblioId;
    }
    return this.get<any[]>('/holds', params);
  }

  cancelHold(holdId: number): Observable<any> {
    return this.delete<any>(`/holds/${holdId}`);
  }
}
